import { Spin } from 'antd';
import moment from 'moment';
import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import ComptrollerDataTable from 'pages/comptroller/comptroller-table/ComptrollerDataTable';

const ListViewAttendanceManagement = ({ data, isLoading }) => {
	const COLUMNS = useMemo(
		() => [
			{
				Header: 'Employee',
				accessor: 'employeeFullName',
			},
			{
				Header: 'Date',
				accessor: 'dateString',
			},
			{
				Header: 'Shift Name',
				accessor: 'shiftName',
			},
			{
				Header: 'Shift Length',
				accessor: 'shiftLength',
			},
			{
				Header: 'Entry Time',
				accessor: (data) => (data?.entryTime ? moment(data.entryTime).utc().format('hh:mm A') : ''),
			},
			{
				Header: 'Earliest Exit Timeline',
				accessor: (data) => (data?.earliestExitTimeline ? moment(data.earliestExitTimeline).utc().format('hh:mm A') : ''),
			},
			{
				Header: 'Exit Time',
				accessor: (data) => (data.exitTime ? moment(data.exitTime).utc().format('hh:mm A') : ''),
			},
			{
				Header: 'Total Hours Worked',
				accessor: 'effectiveWorkingHours',
			},
			{
				Header: 'Status',
				accessor: 'marker',
			},
			{
				Header: 'Overtime Hours',
				accessor: 'overtime',
			},
		],
		[]
	);

	return (
		<Spin spinning={isLoading}>
			<ComptrollerDataTable COLUMNS={COLUMNS} onClickHandler={() => {}} DATA={isEmpty(data) ? [] : data} xlsxFileName="attendance-management" />
		</Spin>
	);
};

export default ListViewAttendanceManagement;
